export type InteractionType = "category_view" | "search" | "product_view";

export function trackInteraction(type: InteractionType, value: string): void {
  fetch("/api/interactions", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ type, value }),
  }).catch(() => {});
}
